import React, { useState } from 'react';
import { Checkbox } from '@mui/material';


export const TypeSignature = ({ onNameChange, onSaveAsDefaultChange, hideSaveDefault }) => {
    const [typedName, setTypedName] = useState('');
    const [saveAsDefault, setSaveAsDefault] = useState(false);

    const clearTyped = () => {
        setTypedName('');
        onNameChange?.('');
    };

    const handleSaveAsDefaultChange = (e) => {
        setSaveAsDefault(e.target.checked);
        onSaveAsDefaultChange?.(e.target.checked);
    };

    return (
        <div>
            <div className="signature-upload-draw-box">
                <div className="type-signature-wrapper">
                    <input
                        type="text"
                        className="type-signature-input"
                        placeholder="Enter your name"
                        value={typedName}
                        onChange={(e) => {
                            setTypedName(e.target.value);
                            onNameChange?.(e.target.value);
                        }}
                    />
                    <div className="type-signature-preview">
                        <p className="type-signature-text">{typedName}</p>
                        <div className="canvas-line" />
                        <div className="type-signature-actions">
                            <div style={{ width: '25%' }} />
                            {!hideSaveDefault && (
                                <div className="type-signature-save-default" style={{ width: '50%' }}>
                                    <Checkbox
                                        checked={saveAsDefault}
                                        onChange={handleSaveAsDefaultChange}
                                        style={{ padding: 0, color: saveAsDefault ? '#347AF0' : '#D0D5DD' }}
                                    />
                                    <span>Save as my default signature</span>
                                </div>
                            )}
                            {hideSaveDefault && <div style={{ width: '50%' }} />}
                            <div style={{ width: '25%', textAlign: 'end' }}>
                                {typedName && (
                                    <button className="type-signature-clear-btn" onClick={clearTyped}>
                                        Clear
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/*<p className="draw-info-text">By signing electronically, I agree to the clinic's terms and conditions.</p>*/}
            </div>
        </div>
    );
};
